/* eslint-disable no-case-declarations */
import { gql } from 'graphql-request';
import { createQuery } from '@fivehealth/botero';
import { get } from 'lodash';

export const GRAPHQL_DELIVERIES_EXPORTED_FORMATS = gql`
  query cleoDeliveriesExportedFormats {
    cleoDeliveries {
      exportFormats {
        label
        outputFormat
        allowEmail
      }
    }
  }
`;

export default createQuery({
  gqlDocument: GRAPHQL_DELIVERIES_EXPORTED_FORMATS,
  queryType: 'query',
  baseQueryKey: 'deliveriesExportedFormats',
  select: (data) =>
    get(data, 'cleoDeliveries.exportFormats')?.map((o) => ({
      value: o.outputFormat?.toLowerCase(),
      label: o.label,
      allowEmail: o.allowEmail,
      selected: false,
    })),
  keepPreviousData: true,
});
